import { forwardRef } from 'react'
import './layout.css'
const PageContent = forwardRef(function PageContent({ as: Tag = 'main', enabled = true, className = '', ...props }, ref) {
    return <Tag {...props} ref={ref} className={[enabled && 'uiPageContent', className].filter(Boolean).join(' ')} />
})
export default PageContent
